import { FaArrowLeft } from 'react-icons/fa'
import { FranchiseList } from './FranchiseList'

import { Container } from './style'

export function FranchiseSelection({ setSelectionDetails }) {
    return (
        <Container>
            <button 
                onClick={() => setSelectionDetails(null)}
                className="backToMenu"
            >
                    <FaArrowLeft /> Menu Principal
            </button>

            <FranchiseList />
        </Container>
    )
}